import { extractAttributeKeys, SSO_ATTRIBUTE_PLACEHOLDER_REGEX } from '../attributes/helpers'

// Invisible characters that browsers can sneak in when text is copied
// (zero-width space, non-joiner, joiner, word joiner, BOM). trim() does not remove most of them.
// Alternation, not a [class]: a joiner inside a class is flagged as misleading by the linter.
const ZERO_WIDTH_CHARS_REGEX = /\u200B|\u200C|\u200D|\u2060|\uFEFF/g

// SZW-FR-001..004: remove invisible characters so pasted values match what the IdP sends.
// SZW-FR-005: text without these characters, and anything that is not a string, comes back
// unchanged, so callers behave exactly as before.
export const stripZeroWidthChars = <T>(value: T): T =>
  typeof value === 'string' ? (value.replace(ZERO_WIDTH_CHARS_REGEX, '') as T) : value

export const formMappingRule = (params, groupId, tenants, roles) => {
  // SZW-FR-002: clean the templates before reading the {attribute} keys out of them
  const usernameAttributeMappingTemplate = stripZeroWidthChars(
    params.usernameAttributeMappingTemplate,
  )
  const emailAttributeMappingTemplate = stripZeroWidthChars(params.emailAttributeMappingTemplate)
  const usernameAttributeKeys = extractAttributeKeys(usernameAttributeMappingTemplate)
  const emailAttributeKeys = extractAttributeKeys(emailAttributeMappingTemplate)

  // Build local templates preserving separators and replacing placeholders with index positions
  const buildIndexedTemplate = (template: string, startIndex: number = 0) => {
    let idx = startIndex
    return template.replace(SSO_ATTRIBUTE_PLACEHOLDER_REGEX, () => {
      const value = `{${idx}}`
      idx += 1
      return value
    })
  }

  const usernameLocal = buildIndexedTemplate(usernameAttributeMappingTemplate)
  const localUsernameTemplate = usernameLocal
  const numUsernameAttributes = usernameAttributeKeys.length
  const emailLocal = buildIndexedTemplate(emailAttributeMappingTemplate, numUsernameAttributes)
  const localEmailTemplate = emailLocal

  const usernameAndEmailAttributes = [
    ...usernameAttributeKeys.map((key) => ({
      type: key,
    })),
    ...emailAttributeKeys.map((key) => ({
      type: key,
    })),
  ]

  const customAttributes = params.customMappings.map((mapping) => {
    return {
      // SZW-FR-002: SAML group attribute name
      type: stripZeroWidthChars(mapping.attribute),
      // SZW-FR-001: each SAML group value
      [mapping.criteria]: stripZeroWidthChars(mapping.values)
        .split(',')
        .map((v) => v.trim()),
      regex: !!mapping.regexMatching,
    }
  })

  // const projects =
  //   Object.keys(params?.roleAssignments)?.map((tenantId: string) => {
  //     return {
  //       name: tenants?.find((tenant) => tenant.id === tenantId)?.name,
  //       roles: [
  //         {
  //           name: roles?.find((role) => role.id === params?.roleAssignments?.[tenantId])?.name,
  //         },
  //       ],
  //     }
  //   }) ?? []

  const newRule = {
    local: [
      {
        user: {
          name: localUsernameTemplate,
          email: localEmailTemplate,
        },
        group: {
          id: groupId,
        },
        // projects,
      },
    ],
    remote: [...usernameAndEmailAttributes, ...customAttributes],
  }
  return newRule
}
